// extracted by mini-css-extract-plugin
export default {"savingModalContainer":"MgY327m6cH8NGEdroD5O","savingModalContent":"PCa5w2xcYhsGWqIS6gho","savingModalText":"yBEWWyqQzQznHJZizIza"};